import { useLocation, useNavigate } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

import { GoBackButton, ProductCard } from '@app/components';
import { PATH_DASHBOARD } from '@app/routes/paths';

const ViewAllScreen = () => {
  const { state } = useLocation();
  const navigation = useNavigate();

  const RenderItem = ({ item }: any, key: number) => {
    return (
      <ProductCard
        key={key}
        image={item?.image}
        dishName={item.label}
        cookingTime={`${item.totalTime} min`}
        ratings={item?.ratings || 'No Rating Yet'}
        description={item.label || item.description}
        id={item?.uri}
        onClick={() => navigation(PATH_DASHBOARD.recipeDetailsScreen, { state: item })}
      />
    );
  };

  return (
    <Stack key={`${state?.collectionName}`}>
      <Typography variant="h5" sx={{ my: 2 }}>
        <GoBackButton /> {state?.collectionName}
      </Typography>
      <Stack
        style={{
          flexDirection: 'row',
          gap: 15,
          width: '100%',
          paddingBottom: 5,
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        {state?.recipes?.map((item: any, index: number) => <RenderItem key={index} item={item} />)}
      </Stack>
    </Stack>
  );
};

export { ViewAllScreen };
